import { RootComponent } from '../root/root.component';
import { ContactUsComponent } from './contact-us/contact-us.component';

import { Routes } from '@angular/router';

export const routing: Routes = [
  {
    path: 'contact',
    component: RootComponent,

    children: [
      { path: '', component: ContactUsComponent },
    ]
  }
];
